import yn from "yn";
import useUserPermission from "~/hooks/useUserPermission";
import { USE_AI_AGENTS } from "~/router/permissions";

/**
 * Whether the user may use AI agents here: they hold `use:agents` and the deployment
 * has not set VITE_AI_AGENTS_ENABLED=false (in its customer `.env.production`).
 */
export const useCanUseAIAgents = (): boolean => {
  const hasPermission = useUserPermission(USE_AI_AGENTS);
  // Read at call time rather than module load so tests can stub it.
  return hasPermission && yn(import.meta.env.VITE_AI_AGENTS_ENABLED, { default: true });
};
